import React from "react";
import "./CodeHide.css";
import CodeHideImage from "../../../assets/CodeHide.jpg";

const CodeHideComponent = () => {
  return (
    <div className="box-Code-Hide-custom">
      <div className="text-container-Code-Hide-custom">
        <div className="title-Code-Hide-custom">CodeHide.com</div>

        <div className="text-Code-Hide-custom">
          At CodeHide.com, innovation is not a mere option; it is a mandate. Our
          platform stands as a beacon for industries, governments, and academia
          alike – a digital haven where aspirations are transmuted into tangible
          achievements. Immerse yourself in a realm where algorithms perform an
          intricate dance, where applications craft masterpieces, and where data
          orchestrates symphonies of insight. Our esteemed team, composed of
          prodigious minds, engineers solutions that stand as a testament to our
          relentless dedication to excellence. From the arcane art of software
          sorcery to the meticulous curation of databases, each facet is
          sculpted by the virtuosos of CodeHide.com. Trust isn't just a word; it
          forms the bedrock of our voyage towards shaping digital destinies.
          <br />
          <br />
          • Personalized software development catering to specific business
          requisites.
          <br />
          • Cutting-edge AI technology and data analysis solutions propelling
          progress.
          <br />
          • Proficiency in database design and management, the keystones of
          digital architecture.
          <br />
          • Premium programming services for crafting web and mobile
          applications.
          <br />• Seamless Content Delivery Network (CDN) solutions for
          unparalleled online experiences.
        </div>
      </div>
      <div className="image-container-right-1-2-custom">
        <img src={CodeHideImage} alt="Square Image" />
      </div>
    </div>
  );
};

export default CodeHideComponent;
